import { FC, ReactNode } from 'react';
import { ContentTypeGuid } from '../types/enums';
import { ContentResponse } from '../types/shared';
import KalenderArkiv from './Kalenderhändelsearkiv/Kalenderhändelsearkiv';
import Nyhetsarkiv from './Nyhetsarkiv/Nyhetsarkiv';
import Samlingssida from './Samlingssida/Samlingssida';
import Standardsida from './Standardsida/Standardsida';
import KalenderhändelseSida from './Kalenderhändelse/KalenderhändelseSida';
interface IContentPageProps {
  contentResponse: ContentResponse;
}

const ContentPage: FC<IContentPageProps> = ({ contentResponse }): ReactNode => {
  const renderContentPage = () => {
    switch (contentResponse.contentTypeGuid) {
      case ContentTypeGuid.Standardsida:
        return <Standardsida contentResponse={contentResponse} />;
      case ContentTypeGuid.Kalenderhändelse:
        return <KalenderhändelseSida contentResponse={contentResponse} />;
      case ContentTypeGuid.Nyhet:
        return <Standardsida contentResponse={contentResponse} />;
      case ContentTypeGuid.Nyhetsarkiv:
        return <Nyhetsarkiv contentResponse={contentResponse} />;
      case ContentTypeGuid.Kalenderhändelsearkiv:
        return <KalenderArkiv contentResponse={contentResponse} />;
      case ContentTypeGuid.Samlingssida:
        return <Samlingssida contentResponse={contentResponse} />;
      default:
        console.warn(`Renderingsimplementation saknas för Page av contentTypeGuid: ${contentResponse.contentTypeGuid}`);
        return <></>;
    }
  };

  return renderContentPage();
};

export default ContentPage;
